/* eslint-disable */
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
// chakra imports
import { Box, Flex, HStack, Text, useColorModeValue } from '@chakra-ui/react';
import HomeIcon from 'assets/icons/homeIcon';
import ProgressIcon from 'assets/icons/progressIcon';
import PeopleIcon from 'assets/icons/peopleIcon';

export function SidebarLinks(props) {
  //   Chakra color mode
  let location = useLocation();
  let activeColor = useColorModeValue('gray.700', 'white');
  let inactiveColor = useColorModeValue(
    'secondaryGray.600',
    'secondaryGray.600',
  );
  let activeIcon = useColorModeValue('brand.500', '#EF6506');
  let textColor = useColorModeValue('secondaryGray.500', '#EF6506');
  let brandColor = useColorModeValue('brand.500', 'brand.400');

  const { routes } = props;

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  // this function creates the links from the secondary accordions (for example auth -> sign-in -> default)
  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (route.category) {
        return (
          <>
            <Text
              fontSize={'md'}
              color={activeColor}
              fontWeight="bold"
              mx="auto"
              ps={{
                sm: '10px',
                xl: '16px',
              }}
              pt="18px"
              pb="12px"
              key={index}
            >
              {route.name}
            </Text>
            {createLinks(route.items)}
          </>
        );
      } else if (
        route.layout === '/admin' ||
        route.layout === '/auth' ||
        route.layout === '/rtl'
      ) {
        return (
          <NavLink key={index} to={route.layout + route.path}>
            {route.icon ? (
              <Box>
                <HStack
                  spacing={
                    activeRoute(route.path.toLowerCase()) ? '22px' : '26px'
                  }
                  py="5px"
                  ps="10px"
                >
                  <Flex
                    w="100%"
                    // alignItems="center"
                    justifyContent="center"
                    alignItems={'center'}
                    flexDirection="column"
                    // marginTop={'2'}
                    // marginBottom={'2'}
                    backgroundColor={
                      activeRoute(route.path.toLowerCase()) ? '#FFEEE3' : null
                    }
                    padding={'12px'}
                    maxWidth={'80px'}
                    borderRadius={'8px'}
                  >
                    <Box
                      alignSelf={'center'}
                      color={
                        activeRoute(route.path.toLowerCase())
                          ? activeIcon
                          : textColor
                      }
                    >
                      {route.icon === 'home' ? (
                        <HomeIcon
                          fill={
                            activeRoute(route.path.toLowerCase())
                              ? '#EF6506'
                              : '#222222'
                          }
                        />
                      ) : route.icon === 'peoples' ? (
                        <PeopleIcon
                          fill={
                            activeRoute(route.path.toLowerCase())
                              ? '#EF6506'
                              : '#222222'
                          }
                        />
                      ) : (
                        <ProgressIcon
                          fill={
                            activeRoute(route.path.toLowerCase())
                              ? '#EF6506'
                              : '#222222'
                          }
                        />
                      )}
                    </Box>
                    <Text
                      alignSelf={'center'}
                      fontSize={'12px'}
                      color={
                        activeRoute(route.path.toLowerCase())
                          ? '#EF6506'
                          : '#222222'
                      }
                      fontWeight={'bold'}
                    >
                      {route.name}
                    </Text>
                  </Flex>
                  {/* <Box
                    h="36px"
                    w="4px"
                    bg={
                      activeRoute(route.path.toLowerCase())
                        ? brandColor
                        : 'transparent'
                    }
                    borderRadius="5px"
                  /> */}
                </HStack>
              </Box>
            ) : (
              <Box>
                {/* <HStack
                  spacing={
                    activeRoute(route.path.toLowerCase()) ? '22px' : '26px'
                  }
                  py="5px"
                  ps="10px"
                >
                  <Text
                    me="auto"
                    color={
                      activeRoute(route.path.toLowerCase())
                        ? activeColor
                        : inactiveColor
                    }
                    fontWeight={
                      activeRoute(route.path.toLowerCase()) ? 'bold' : 'normal'
                    }
                  >
                    {route.name}
                  </Text>
                  <Box h="36px" w="4px" bg="brand.400" borderRadius="5px" />
                </HStack> */}
              </Box>
            )}
          </NavLink>
        );
      }
    });
  };
  //  BRAND
  return createLinks(routes);
}

export default SidebarLinks;
